import { render, staticRenderFns } from "./digital-factory.vue?vue&type=template&id=6ead3134&scoped=true&"
import script from "./digital-factory.vue?vue&type=script&lang=js&"
export * from "./digital-factory.vue?vue&type=script&lang=js&"
import style0 from "./digital-factory.vue?vue&type=style&index=0&id=6ead3134&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ead3134",
  null
  
)

export default component.exports